
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { hideSignup } from './components/footer/hideSignup.js';
import { handleMenuHover } from './components/footer/handleMenuHover.js';
import { ticketingBlocksSlider } from './components/footer/ticketingBlocksSlider.js';
import { farloUiLightboxBlock } from './vendors/farlo-ui-lighbox-block.js';
import { ticker } from './components/footer/ticker.js';
import { tourLightbox } from './components/footer/tourLightbox.js';
import { activateToggleView } from './components/footer/activateToggleView.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};
	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}



		if (document.querySelector('.site-main')) {
			addScrolledClass();
		}

		if (document.querySelector('.choose-shows')) {
			activateToggleView();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.is-style-mobile-slider')) {
			document.querySelectorAll('.is-style-mobile-slider').forEach((_sel) => {
				ticketingBlocksSlider(_sel);
			});
		}


		if (document.querySelector('.site-creative-team')) {
			document.querySelectorAll('.site-creative-team').forEach((_sel) => {
				ticketingBlocksSlider(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}
		if (document.querySelector('.menu-item')) {
			handleMenuHover();
		}

		if (document.querySelector('.site-marquee__ticker')) {
			document.querySelectorAll('.site-marquee__ticker').forEach((_sel) => {
				ticker(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox-toggle')) {
			farloUiLightboxBlock();
		}

		if (document.querySelector('.home') && document.querySelector('.button--book')) {
			//hideSignup();
		}

		if (document.querySelector('.open-signup')) {
			tourLightbox();
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function (button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function (block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		// document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
		// 	smoothScrollToAnchor(_sel);
		// });

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		document.querySelectorAll('[data-signup]').forEach((btn) => {
			btn.addEventListener('click', (e) => {

			});
		});

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function (buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
